import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import useCollection from "areas/collection/hoc/use-collection"
import { updateNewPageStartIndex } from "areas/collection/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const LoadMoreProducts = ({ newPageFocusRef }) => {
  const dispatch = useDispatch()
  const newPageStartIndex = useSelector(
    (state) => state.collection.newPageStartIndex
  )

  const { data = {}, fetchNextPage, isFetchingNextPage } = useCollection()
  const currentNumOfProducts = data.product_result?.length ?? -1
  const {
    current_page_number,
    next_page,
    results_per_page,
    total_product_count,
  } = data.pagination ?? {}

  useEffect(() => {
    // Maintain focus on the first product of the new page
    // on Load More button click
    if (!isFetchingNextPage && newPageFocusRef.current) {
      newPageFocusRef.current.focus()
    }
  }, [isFetchingNextPage, newPageStartIndex, newPageFocusRef])

  return (
    <div className="flex flex-col items-center justify-center gap-20 px-20 py-8">
      <p aria-live="polite" className="text-grey-65 text-14 leading-16">
        Viewing {current_page_number * results_per_page} of{" "}
        {total_product_count} Products
      </p>
      <Button
        aria-disabled={isFetchingNextPage}
        aria-label={
          isFetchingNextPage ? "Loading more products" : "View more products"
        }
        asChild
        className="w-260"
        data-cy="collection-load-product-button"
        loading={isFetchingNextPage}
        variant="secondary"
      >
        <Link
          onClick={(e) => {
            e.preventDefault()
            if (!isFetchingNextPage) {
              dispatch(updateNewPageStartIndex(currentNumOfProducts))
              fetchNextPage()
            }
          }}
          replace
          to={`/${next_page}`}
        >
          {isFetchingNextPage ? "Loading" : "View More"}
          {isFetchingNextPage && (
            <FontAwesomeIcon className="ml-4" icon={faSpinner} spin />
          )}
        </Link>
      </Button>
    </div>
  )
}

LoadMoreProducts.propTypes = {
  newPageFocusRef: PropTypes.object,
}

export default LoadMoreProducts
